import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
}

export default function deleteProject(state = initialState, action) {
    switch (action.type) {
        case type.DELETE_IGNORE_THIS_PROJECT_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.DELETE_IGNORE_THIS_PROJECT_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case type.DELETE_IGNORE_THIS_PROJECT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}